var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.timer
    ? _c(
        "section",
        { staticClass: "withdrawal-delay" },
        [
          _c("detail", {
            attrs: { prop: _vm.i18n.lbl_time_to_tx(), value: _vm.timer }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "withdrawal-delay__controls" },
            [
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: { disabled: _vm.pending },
                  on: { click: _vm.cancel }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: { disabled: _vm.pending },
                  on: { click: _vm.send }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_send_immediatly()))]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587a8e1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587a8e1d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/WithdrawalDelay.vue
// module id = ylU+
// module chunks = 1